// The host-view signal contract — what a hosted webview page says to whatever is hosting it.
//
// These follow the same `Subject-camelCaseEvent` vocabulary as the session signals (see
// constants/session_events.js), with one difference worth naming: `Person-*` signals ANNOUNCE a
// state change, while `HostView-*` signals REQUEST something of the host. Same shape, opposite
// direction of obligation.
//
// They are deliberately generic — nothing about onboarding is in the names — so any page that a
// native shell puts behind a cover, or inside a dismissible view, can use them. Each host decides
// what the request means for it (the onboarding host sets its seen-flag and fades out; a future
// Reviews webview would simply finish).
//
// Emitted over the existing `to_native/signals/new` channel (NativeAppSignalEmitter). On the web
// there is no native host, so the page's own overlay host listens for the equivalent DOM event.
// Old native app versions no-op on unknown signals.

// "I am ready to be shown" — the slides and their artwork have settled. Both apps hold their
// splash/cover until this arrives, because `didFinish`/`onPageFinished` can be too early and the
// reveal must never show a loading webview.
export const HOST_VIEW_CONTENT_READY_EVENT = "HostView-contentReady";

// "Close whatever hosts me." Both the Continue button and the close cross emit this — completed
// versus dismissed is an analytics distinction (SLIDES_COMPLETED / SLIDES_DISMISSED), not a state
// the host needs to know about.
export const HOST_VIEW_CLOSE_EVENT = "HostView-close";
